import { memo, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "sipli-fleet-core/components/CustomSharedButton/CustomSharedButton";
import CustomTooltip from "sipli-fleet-core/components/CustomSharedTooltip/CustomSharedTooltip";

export interface CustomEmptyListStateProps {
  icon?: string;
  iconAlt?: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  buttonDisabled?: boolean;
  buttonDisabledTooltip?: string;
  className?: string;
  iconClassName?: string;
}

function CustomEmptyListState({
  icon,
  iconAlt,
  title,
  description,
  buttonLabel,
  onButtonClick,
  buttonDisabled = false,
  buttonDisabledTooltip,
  className = "",
  iconClassName = "mb-6 w-32 h-32",
}: CustomEmptyListStateProps) {
  const { t } = useTranslation();

  const button =
    buttonLabel &&
    ((
      <CustomTooltip
        title={
          buttonDisabled && buttonDisabledTooltip ? buttonDisabledTooltip : ""
        }
      >
        <CustomButton
          type="primary"
          label={t(buttonLabel)}
          disabled={buttonDisabled}
          onClick={onButtonClick}
        />
      </CustomTooltip>
    ) as ReactNode);

  return (
    <div
      className={`flex flex-col items-center justify-center h-full p-8 ${className}`}
    >
      {icon && (
        <img
          src={icon}
          alt={iconAlt || t("empty_state")}
          className={iconClassName}
        />
      )}
      {title && <h3 className="text-lg font-semibold mb-2">{t(title)}</h3>}
      {description && (
        <p className="text-gray-600 mb-6 text-center">{t(description)}</p>
      )}
      {button}
    </div>
  );
}

export default memo(CustomEmptyListState);
